 const ListBookDefautl = [
  {
    id:1,
    name: "Guitar Suzuki SDG-6BK (Acoustic)",
    urlImg: "https://upload-img-theta.vercel.app/guitar.png",
    quantity: "10",
    price: 2500000,
    color: "Black",
    type: "Acoustic",
    description:"Guitar Suzuki SDG-6BK là mẫu đàn Acoustic, đây là loại đàn thông dụng và phổ biến dành cho lứa tuổi học sinh, sinh viên, người mới tập chơi guitar chọn lựa.",
  },
 

];

export {ListBookDefautl}
